import { useState } from "react";
import React from "react";
import {
  ButtonComp,
  FileUploaderComp,
  ImageLoaderUpdate,
  SelectComp2,
  TextInputComp,
  CardComp,
} from "../../../../components";
import { Formik, Form } from "formik";
import { useEditBranchMutation } from "../../../../store/admin/settings/branchSlice";
import {
  useGetCountriesQuery,
  useGetCitiesQuery,
} from "../../../../store/selectableSlice";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
const phoneRegExp = /^([0]{1})[0-9]{10}$/;

export default function EditBranch({ onNext, branchDetails }) {
  // State for dropdown selections
  const [selectedCountry, setSelectedCountry] = useState(
    branchDetails.country
      ? { value: branchDetails.country.id, label: branchDetails.country.name }
      : null
  );
  const [selectedCity, setSelectedCity] = useState(
    branchDetails.city
      ? { value: branchDetails.city.id, label: branchDetails.city.name }
      : null
  );
  const [branchPhoto, setBranchPhoto] = useState(branchDetails.photo || null);
  const [withLogo, setWithLogo] = useState(false);

  // Get countries and cities data (backend now returns sorted alphabetically)
  const { data: countries = [], isLoading: isLoadingCountries } =
    useGetCountriesQuery();
  const { data: cities = [], isLoading: isLoadingCities } = useGetCitiesQuery();

  // Filter cities based on selected country (backend already sorts alphabetically)
  const filteredCities = selectedCountry
    ? cities.filter((city) => city.country_id === selectedCountry.value)
    : [];

  const handleCountryChange = (countrySelected) => {
    setSelectedCountry(countrySelected);
    setSelectedCity(null); // Reset city when country changes
  };

  const handleCityChange = (citySelected) => {
    setSelectedCity(citySelected);
  };

  const handlePhotoUpload = (photoUrl) => {
    setBranchPhoto(photoUrl);
  };

  const initialValues = {
    address: branchDetails.address || "",
    name: branchDetails.name || "",
    phone: branchDetails.phone || "",
    email: branchDetails.email || "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Branch name cannot be empty"),
    phone: Yup.string()
      .matches(phoneRegExp, "Phone number must be eleven digits")
      .required("Phone number is required"),
    email: Yup.string()
      .email("Field must be a valid email")
      .required("Email is required"),
    address: Yup.string().required("Address cannot be empty"),
  });

  const [submitEditForm, { isLoading }] = useEditBranchMutation();

  const handleSubmit = async (values, { setSubmitting }) => {
    // Validate that country and city are selected
    if (!selectedCountry || !selectedCity) {
      toast.error("Please select both country and city");
      return;
    }

    const reqBody = {
      name: values.name,
      phone: values.phone,
      email: values.email,
      address: values.address,
      country_id: selectedCountry.value,
      city_id: selectedCity.value,
      photo: withLogo ? null : branchPhoto, // If using cooperative logo, don't send custom photo
      use_cooperative_logo: withLogo,
      branchId: branchDetails.id,
    };

    try {
      setSubmitting(true);
      const toastId = toast.loading("Updating branch...");

      const payload = await submitEditForm(reqBody);
      const { data, error } = payload;

      if (error) {
        return toast.error(error?.data?.message || "An error occurred", {
          id: toastId,
        });
      }

      if (data?.status === false) {
        return toast.error(data.message || "An error occurred", {
          id: toastId,
        });
      }

      if (data.status === true) {
        return toast.success(data.message || "Branch updated successfully!", {
          id: toastId,
        });
      }
    } catch (error) {
      toast.error("An error occurred");
    } finally {
      setSubmitting(false);
    }
  };

  console.log(branchDetails, "branchDetails");

  return (
    <>
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <Form>
            <CardComp
              cardClassName={"pt-4"}
              cardBodyClassName={"py-0 row gx-5 gy-3 justify-content-between"}
            >
              <div className="col-12 col-lg-5">
                <div className="mb-3">
                  <TextInputComp
                    LabelText={"Branch name"}
                    borderColor="#A1A0A0"
                    LabelClassName={"fw-2"}
                    placeholder={"Input branch name"}
                    name="name"
                  />
                </div>
                <div className="mb-3">
                  <SelectComp2
                    LabelClassName={"fw-2"}
                    labelText={"Country"}
                    arrayComp={[
                      { value: "", label: "Select Country" },
                      ...countries.map((country) => ({
                        value: country.id,
                        label: country.name,
                      })),
                    ]}
                    setSelectedOption={handleCountryChange}
                    isLoading={isLoadingCountries}
                    selectedValue={selectedCountry}
                    isSearchable={true}
                  />
                </div>
                <div className="mb-3">
                  <SelectComp2
                    LabelClassName={"fw-2"}
                    labelText={"City/State"}
                    arrayComp={[
                      { value: "", label: "Select City/State" },
                      ...filteredCities.map((city) => ({
                        value: city.id,
                        label: city.name,
                      })),
                    ]}
                    setSelectedOption={handleCityChange}
                    isLoading={isLoadingCities}
                    disabled={!selectedCountry}
                    selectedValue={selectedCity}
                    isSearchable={true}
                  />
                </div>
                <div className="mb-3">
                  <TextInputComp
                    LabelText={"Phone number"}
                    borderColor="#A1A0A0"
                    LabelClassName={"fw-2"}
                    placeholder={"Enter Phone number"}
                    name="phone"
                  />
                </div>
                <div className="mb-3">
                  <TextInputComp
                    LabelText={"Email address"}
                    borderColor="#A1A0A0"
                    LabelClassName={"fw-2"}
                    placeholder={"Enter Email"}
                    name="email"
                  />
                </div>
                {/* <div className="mb-3">
                  <SelectComp2
                    LabelClassName={"fw-2"}
                    labelText={"State"}
                    arrayComp={[
                      { value: "", label: "Select Location" },
                      {
                        value: "Lagos",
                        label: "Lagos",
                      },
                    ]}
                  />
                </div> */}
                {/* <div className="mb-3">
                  <SelectComp2
                    LabelClassName={"fw-2"}
                    labelText={"Select bank"}
                    arrayComp={[
                      { value: "", label: "Select Bank" },
                      {
                        value: "GTB",
                        label: "GTB",
                      },
                    ]}
                  />
                </div> */}
              </div>
              <div className="col-12 col-lg-5">
                <div className="mb-3">
                  <TextInputComp
                    LabelText={"Address"}
                    borderColor="#A1A0A0"
                    LabelClassName={"fw-2"}
                    placeholder={"Enter Address"}
                    name="address"
                  />
                </div>
                <div className="mb-4">
                  <FileUploaderComp
                    LabelText={"Profile Image"}
                    labelClassName={"fw-2"}
                    accept="image/*"
                    bodyText={
                      <div className="d-flex align-items-center">
                        <ImageLoaderUpdate
                          src={"/FileUploader/upload.svg"}
                          style={{ width: "60%" }}
                          className="me-3"
                        />

                        <div className="fw-2" style={{ color: "#6B6B6B" }}>
                          {withLogo
                            ? "Using Cooperative Logo"
                            : "Click to Upload Image"}
                        </div>
                      </div>
                    }
                    onChange={handlePhotoUpload}
                  />
                  {withLogo && (
                    <div className="mt-2">
                      <small className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        Branch will use the cooperative's main logo instead of a
                        custom image.
                      </small>
                    </div>
                  )}
                </div>
                <div>
                  <div className="form-check d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="useCooperativeLogoEdit"
                      checked={withLogo}
                      onChange={(e) => setWithLogo(e.target.checked)}
                      style={{
                        width: "22px",
                        height: "22px",
                        marginTop: "0",
                      }}
                    />
                    <label
                      className="form-check-label ms-3"
                      htmlFor="useCooperativeLogoEdit"
                    >
                      use cooperative logo
                    </label>
                  </div>
                </div>
              </div>
            </CardComp>

            <div className="">
              <ButtonComp
                btnText={"Update branch"}
                disabled={isLoading}
                btnClassName={
                  "bg-primary1 py-3 px-4 text-white border-0 rounded"
                }
                type={"submit"}
                loading={isLoading}
              />
            </div>
          </Form>
        </Formik>
      </div>
    </>
  );
}
